/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { TitreDiplomeCertificationGridDto } from './TitreDiplomeCertificationGridDto';
import {
    TitreDiplomeCertificationGridDtoFromJSON,
    TitreDiplomeCertificationGridDtoFromJSONTyped,
    TitreDiplomeCertificationGridDtoToJSON,
} from './TitreDiplomeCertificationGridDto';

/**
 * 
 * @export
 * @interface TitreDiplomeCertificationGridDtoPaginatedResults
 */
export interface TitreDiplomeCertificationGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof TitreDiplomeCertificationGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<TitreDiplomeCertificationGridDto>}
     * @memberof TitreDiplomeCertificationGridDtoPaginatedResults
     */
    results?: Array<TitreDiplomeCertificationGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof TitreDiplomeCertificationGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the TitreDiplomeCertificationGridDtoPaginatedResults interface.
 */
export function instanceOfTitreDiplomeCertificationGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TitreDiplomeCertificationGridDtoPaginatedResultsFromJSON(json: any): TitreDiplomeCertificationGridDtoPaginatedResults {
    return TitreDiplomeCertificationGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function TitreDiplomeCertificationGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): TitreDiplomeCertificationGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(TitreDiplomeCertificationGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function TitreDiplomeCertificationGridDtoPaginatedResultsToJSON(value?: TitreDiplomeCertificationGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(TitreDiplomeCertificationGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

